import { render, staticRenderFns } from "./TermsConditionsModal.vue?vue&type=template&id=5a620105"
import script from "./TermsConditionsModal.vue?vue&type=script&lang=js"
export * from "./TermsConditionsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports